import React, { useEffect, useState } from 'react';
import { Table, Tag, message } from 'antd';
import { OrgUser } from '../../interfaces/orgManagement';
import orgManagementService from '../../apiServices/orgManagementService';
import "../../assets/css/tablesShadow.css"

interface OrgUsersTableProps {
    orgId: string;
}

const OrgUsersTable: React.FC<OrgUsersTableProps> = ({ orgId }) => {
    const [users, setUsers] = useState<OrgUser[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchOrgUsers();
    }, [orgId]);

    const fetchOrgUsers = async () => {
        setLoading(true);
        try {
            const orgUsers = await orgManagementService.getOrgUsers(orgId);
            setUsers(orgUsers);
        } catch (error) {
            console.error('Error fetching org users:', error);
            message.error('Failed to load account users');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render: (role: string) => <Tag color="blue">{role?.toUpperCase()}</Tag>,
        }
    ];

    return (
        <div className="p-4 bg-gray-50 rounded mt-4">
            <h3 className="mb-2 font-medium text-gray-700">Assigned Users</h3>
            <Table
                columns={columns}
                dataSource={users}
                rowKey="user_id"
                loading={loading}
                pagination={false}
                size="small"
            />
        </div>
    );
};

export default OrgUsersTable;
